import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Global from '../../store/global-selectors';
import { demoOrder1, demoProducts, demoShipFrom, demoTag, ORDER_DEMO_TYPE } from '../demo-orders';
import { demoSetupStart } from '../../store/demos/demos.actions';

export const useCreateDemoOrder = () => {
  const dispatch = useDispatch();
  const existingShipFroms = useSelector(Global.selectSellerShipFroms);

  return useCallback(async () => {
    let props = {
      demoTypes: ORDER_DEMO_TYPE,
      tagData: demoTag,
      demoSetupData: demoOrder1,
      demoProducts,
    };
    if (!existingShipFroms.length) {
      props = { ...props, demoShipFrom };
    }
    dispatch(demoSetupStart(props));
  }, [dispatch, existingShipFroms.length]);
};
